import { useState, useCallback } from 'react';
import { FeatureList, Feature } from '../types/api';

export const useFeatureList = () => {
  const [featureList, setFeatureList] = useState<FeatureList | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateFeatureDescription = useCallback((feature: Feature, newDescription: string) => {
    if (!featureList) return;

    setFeatureList(prev => {
      if (!prev) return null;

      return {
        ...prev,
        groups: prev.groups.map(group => ({
          ...group,
          features: group.features.map(f => 
            f.featureNumber === feature.featureNumber && 
            f.featureName === feature.featureName
              ? { ...f, featureDescription: newDescription }
              : f
          )
        }))
      };
    });
  }, [featureList]);

  const resetState = useCallback(() => {
    setFeatureList(null);
    setError(null);
  }, []);

  return {
    featureList,
    loading,
    error,
    setFeatureList,
    setLoading,
    setError,
    updateFeatureDescription,
    resetState,
  };
};
